import styled, { css, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

const popIn = keyframes`
  from { opacity: 0; transform: translateY(8px) scale(0.98); }
  to { opacity: 1; transform: none; }
`

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(16, 24, 32, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1000;
  animation: ${fadeIn} 0.15s ease-out;
`

export const ModalWrapper = styled.div`
  position: relative;
  background: #ffffff;
  border-radius: 20px;
  width: 560px;
  max-width: 100%;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  box-shadow: 0 24px 64px rgba(16, 24, 32, 0.24);
  animation: ${popIn} 0.15s ease-out;
`

export const ModalContent = styled.div`
  padding: 40px 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  ${({ $processing }) => $processing && css`
    padding: 48px 32px 40px;
    min-height: 360px;
    justify-content: center;
  `}
`

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 48px;
  height: 48px;
  padding: 0;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: var(--color-muted);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.1s;

  svg {
    width: 22px;
    height: 22px;
  }

  &:active {
    background: var(--color-line);
  }
`

export const ModalHeader = styled.h2`
  margin: 0;
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--color-muted);
`

export const ModalTotal = styled.div`
  margin: 8px 0 32px;
  font-size: 3.25rem;
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  color: ${({ theme }) => theme.colors.global};

  ${({ $small }) => $small && css`
    margin: 8px 0 0;
    font-size: 1.75rem;
    font-weight: 700;
    color: var(--color-muted);
  `}
`

export const PaymentMethods = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 100%;
`

export const PaymentMethodButton = styled.button`
  min-height: 176px;
  padding: 24px 16px;
  border: 1.5px solid var(--color-line);
  border-radius: var(--radius-card, 14px);
  background: #ffffff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  font-family: inherit;
  transition: border-color 0.1s, background 0.1s, transform 0.1s;
  -webkit-tap-highlight-color: transparent;

  .icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.primary}14;
    color: ${({ theme }) => theme.colors.primaryText || theme.colors.primary};

    svg {
      width: 40px;
      height: 40px;
    }
  }

  .label {
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--color-text);
  }

  &:active {
    border-color: ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.primary}0A;
    transform: scale(0.98);
  }
`

const spin = keyframes`
  to { transform: rotate(360deg); }
`

export const ProcessingRing = styled.div`
  position: relative;
  width: 112px;
  height: 112px;
  margin-bottom: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.primary}10;
  color: ${({ theme }) => theme.colors.primaryText || theme.colors.primary};

  > svg {
    width: 44px;
    height: 44px;
  }
`

export const ProcessingSpinner = styled.div`
  position: absolute;
  inset: 0;
  border: 3px solid ${({ theme }) => theme.colors.primary}22;
  border-top-color: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 1.1s linear infinite;
`

export const PaymentProcessingText = styled.div`
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--color-text);
`
